var render = function render(){var _vm=this,_c=_vm._self._c;return _c('public-profile',{attrs:{"serviceProviderOccupationId":_vm.serviceProviderOccupationId,"profile":_vm.profile}})
}
var staticRenderFns = []

export { render, staticRenderFns }